import styled from 'styled-components';
import { colors, Cell } from '@dexma/ui-components';

export const StyledWidgetSelector = styled.div<{ $error: boolean }>`
    width: 100%;
    padding: 20px 30px 0px 30px;
    .widget-type-block span {
        font-weight: 700;
        color: ${colors.gray700};
    }

    .DateRangePickerInput,
    .select-styled__control,
    .form-control-input,
    .form-control-textarea {
        border-color: ${(props) => props.$error && colors.red};
    }

    .error {
        color: ${colors.red};
        text-align: left;
    }
`;

export const StyledSelectCell = styled(Cell)`
    margin-top: 4px;
    // This accesor is required to override the default style of the dropdown menu on Select component
    // as it is not possible to do it with styled-components. It's affected by the global styles of the
    // alert included on the top of the page, and it provokes to misplace the dropdown menu. This is a workaround
    // to fix it, but it should be removed when the global styles are fixed.
    > div > div > div:nth-child(3) {
        position: static;
    }
`;
